import { render, staticRenderFns } from "./ModalAddAudioAffirmations.vue?vue&type=template&id=2547dbd6&scoped=true&"
import script from "./ModalAddAudioAffirmations.vue?vue&type=script&lang=js&"
export * from "./ModalAddAudioAffirmations.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddAudioAffirmations.vue?vue&type=style&index=0&id=2547dbd6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2547dbd6",
  null
  
)

export default component.exports